<!--充值明细-->
<template>
    <div class="home-main agent">
        <div class="main">
            <div class="main_title">
                <span class="title-cn">代理商设置</span> <span class="title-en">/Agent Setting</span>
            </div>
            <!--筛选部分start-->
            <div class="agent-selector">
                <div class="select-item">
                    <p>伙伴名称</p>
                    <el-input v-model="searchOption.name" class="select-input" size="small" clearable></el-input>
                </div>
                <div class="select-item">
                    <p>伙伴用户名</p>
                    <el-input v-model="searchOption.username" class="select-input" size="small" clearable></el-input>
                </div>

                <el-button size="small" class="warning" @click="search">搜索</el-button>
                <el-button size="small" @click="restSearch">重置</el-button>
            </div>
            <!--筛选部分end-->

            <div class="agent-main-line"></div>

            <!--订单列表start-->
            <div class="agent-main-list">
                <el-table height="100%" :data="tableData" style="width: 100%" stripe>
                    <el-table-column width="40"> </el-table-column>
                    <el-table-column label="伙伴名称">
                        <template slot-scope="scope">
                            <span>{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="伙伴用户名">
                        <template slot-scope="scope">
                            <span>{{ scope.row.username }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="注册时间">
                        <template slot-scope="scope">
                            <span>{{ scope.row.create_time }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="代理伙伴">
                        <template slot-scope="scope">
                            <span>{{ scope.row._is_agent }}</span>

                            <!-- <span>{{ scope.row.status === 0 ? '是' : '否' }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="天智销售">
                        <template slot-scope="scope">
                            <span>{{ scope.row._is_sales }}</span>

                            <!-- <span>{{ scope.row.allow_oem ? '是' : '否' }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="运营管理">
                        <template slot-scope="scope">
                            <span>{{ scope.row._is_operator }}</span>

                            <!-- <span>{{ scope.row.allow_offline ? '是' : '否' }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="FastBI">
                        <template slot-scope="scope">
                            <span>{{ scope.row._is_product }}</span>

                            <!-- <span>{{ scope.row.is_maintainer ? '是' : '否' }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="OCR">
                        <template slot-scope="scope">
                            <span>{{ scope.row._is_package }}</span>

                            <!-- <span>{{ scope.row.is_developer ? '是' : '否' }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="加密狗">
                        <template slot-scope="scope">
                            <span>{{ scope.row._is_softwareDongle }}</span>

                            <!-- <span>{{ scope.row.allow_xzreport ? '是' : '否' }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="离线授权">
                        <template slot-scope="scope">
                            <span>{{ scope.row._is_offline }}</span>

                            <!-- <span>{{ scope.row.allow_af ? '是' : '否' }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="OEM管理">
                        <template slot-scope="scope">
                            <span>{{ scope.row._is_oem }}</span>

                            <!-- <span>{{ scope.row.allow_af ? '是' : '否' }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="小智SDK">
                        <template slot-scope="scope">
                            <span>{{ scope.row._is_sdk }}</span>

                            <!-- <span>{{ scope.row.allow_af ? '是' : '否' }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="开发平台">
                        <template slot-scope="scope">
                            <span>{{ scope.row._is_development }}</span>

                            <!-- <span>{{ scope.row.allow_af ? '是' : '否' }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="安捷云公有云">
                        <template slot-scope="scope">
                            <span>{{ scope.row._is_cloud }}</span>

                            <!-- <span>{{ scope.row.allow_af ? '是' : '否' }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="安捷云本地化">
                        <template slot-scope="scope">
                            <span>{{ scope.row._is_local }}</span>

                            <!-- <span>{{ scope.row.allow_af ? '是' : '否' }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="安捷智用产品">
                        <template slot-scope="scope">
                            <span>{{ scope.row._is_fdc }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="归属维护人">
                        <template slot-scope="scope">
                            <span>{{ scope.row.staffname }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="300" class="table-status">
                        <template slot-scope="scope">
                            <el-button size="mini" type="primary"
                                @click="permissionOpen(scope.$index, scope.row)">权限开通</el-button>
                            <el-button size="mini" type="primary"
                                @click="priceSetting(scope.$index, scope.row)">价格设置</el-button>
                            <el-button size="mini" type="primary"
                                @click="accountRecharge(scope.$index, scope.row)">账户充值</el-button>
                            <el-button size="mini" type="primary"
                                @click="resetPassword(scope.$index, scope.row)">重置密码</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--订单列表end-->
            <div class="pagination">
                <el-pagination :disabled="!pagination.use" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page="pagination.currentPage"
                    :page-sizes="[20, 30, 50, 100]" :page-size="pagination.size"
                    layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
                </el-pagination>
            </div>

            <!-- 权限开通start -->
            <el-dialog title="权限开通" :close-on-click-modal="false" :visible.sync="agentVisable" width="506px">
                <el-form :model="agentFormInfo" ref="agentFormInfo">
                    <el-form-item label="伙伴名称" prop="name" :label-width="formLabelWidth">
                        <el-input disabled v-model="agentFormInfo.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="伙伴用户名" prop="user.username" :label-width="formLabelWidth">
                        <el-input disabled v-model="agentFormInfo.user.username" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="总经理/CEO" prop="ceo_name" :label-width="formLabelWidth">
                        <el-input disabled v-model="agentFormInfo.ceo_name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="ceo_mobile" :label-width="formLabelWidth">
                        <el-input disabled v-model="agentFormInfo.ceo_mobile" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="电话" prop="ceo_phone" :label-width="formLabelWidth">
                        <el-input disabled v-model="agentFormInfo.ceo_phone" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="ceo_email" :label-width="formLabelWidth">
                        <el-input disabled v-model="agentFormInfo.ceo_email" autocomplete="off"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="伙伴权限" prop="permission" :label-width="formLabelWidth">
            <el-checkbox-group v-model="agentForm.permission">
              <el-checkbox v-for="(item, index) in partnerPermission" :key="index" :label="item.id">{{
                item.name
              }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item> -->
                    <el-form-item label="身份权限" prop="role" :label-width="formLabelWidth">
                        <el-checkbox-group v-model="agentForm.role">
                            <el-checkbox v-for="(item, index) in partnerPermission1" :key="index" :label="item.id">{{
                                item.name
                                }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="FastBI产品" prop="fastbi" :label-width="formLabelWidth">
                        <el-checkbox-group v-model="agentForm.fastbi">
                            <el-checkbox v-for="(item, index) in partnerPermission2" :key="index" :label="item.id">{{
                                item.name
                                }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="小智产品" prop="xz" :label-width="formLabelWidth">
                        <el-checkbox-group v-model="agentForm.xz">
                            <el-checkbox v-for="(item, index) in partnerPermission3" :key="index" :label="item.id">{{
                                item.name
                                }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="安捷云产品" prop="af" :label-width="formLabelWidth">
                        <el-checkbox-group v-model="agentForm.af">
                            <el-checkbox v-for="(item, index) in partnerPermission4" :key="index" :label="item.id">{{
                                item.name
                                }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="安捷智用产品" prop="fdc" :label-width="formLabelWidth">
                        <el-checkbox-group v-model="agentForm.fdc">
                            <el-checkbox v-for="(item, index) in partnerPermission5" :key="index" :label="item.id">{{
                                item.name
                                }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="归属维护人" :label-width="formLabelWidth">
                        <el-select v-model="agentForm.staff" placeholder="请选择">
                            <el-option v-for="(item, key) in maintainer" :key="key" :label="item.username"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="hideAgentDialog">取 消</el-button>
                    <el-button class="primary" @click="agentFormSubmit">提 交</el-button>
                </div>
            </el-dialog>
            <!-- 权限开通end -->
            <!-- 价格设置start -->

            <el-dialog title="价格设置" :close-on-click-modal="false" :visible.sync="priceVisable" width="800px">
                <div class="account-table">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <!-- <el-tab-pane v-for="item in priceConfig" :label="item.label" :name="item.id" :key="item.id">
              <el-table :data="item.data" border style="width: 100%" height="600">
                <el-table-column prop="name" label="名称"> </el-table-column>
                <el-table-column label="按年开通" align="center">
                  <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.price_info.valid"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="按年结算价格">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.price_info.price"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="买断开通" align="center">
                  <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.price_info.buyout_valid"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="买断结算价格">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.price_info.buyout_price"></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane> -->
                        <el-tab-pane :label="priceConfig.editions.label" :name="priceConfig.editions.id">
                            <div class="af_main">
                                <div class="af_main_item">
                                    <span style="margin-right: 20px;">伙伴结算折扣</span>
                                    <el-input-number controls-position="right" size="small"
                                        v-model="priceConfig.fbi_discount" :min="0" :max="1" label="填0-1的值"
                                        :step="0.1"></el-input-number>
                                    <span style="margin-left: 20px;">（备注：填0-1的值）</span>
                                </div>
                                <div class="">
                                    <span>产品版本授权设置</span>
                                    <div style="margin-top: 20px;">
                                        <el-table :data="priceConfig.editions.data" border style="width: 500px"
                                            height="499">
                                            <el-table-column prop="name" label="名称"> </el-table-column>
                                            <el-table-column label="按年市场价" align="center">
                                                <template slot-scope="scope">
                                                    {{ scope.row.price_info.price }}
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="是否开通" align="center">
                                                <template slot-scope="scope">
                                                    <el-checkbox v-model="scope.row.price_info.valid"></el-checkbox>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane :label="priceConfig.modules.label" :name="priceConfig.modules.id">
                            <div class="af_main">
                                <div class="">
                                    <span>产品模块授权设置</span>
                                    <div style="margin-top: 20px;">
                                        <el-table :data="priceConfig.modules.data" border style="width: 500px"
                                            height="499">
                                            <el-table-column prop="name" label="名称"> </el-table-column>
                                            <el-table-column label="按年市场价" align="center">
                                                <template slot-scope="scope">
                                                    {{ scope.row.price_info.price }}
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="是否开通" align="center">
                                                <template slot-scope="scope">
                                                    <el-checkbox v-model="scope.row.price_info.valid"></el-checkbox>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane :label="priceConfig.suits.label" :name="priceConfig.suits.id">
                            <div class="af_main">
                                <div class="">
                                    <span>产品模块授权设置</span>
                                    <div style="margin-top: 20px;">
                                        <el-table :data="priceConfig.suits.data" border style="width: 500px"
                                            height="499">
                                            <el-table-column prop="name" label="名称"> </el-table-column>
                                            <el-table-column label="按年市场价" align="center">
                                                <template slot-scope="scope">
                                                    {{ scope.row.price_info.price }}
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="是否开通" align="center">
                                                <template slot-scope="scope">
                                                    <el-checkbox v-model="scope.row.price_info.valid"></el-checkbox>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                        <!-- <el-tab-pane :label="priceConfig.xzreports.label" :name="priceConfig.xzreports.id">
              <div class="af_main">
                <div class="af_main_item">
                  <span style="margin-right: 20px;">伙伴结算折扣</span>
                  <el-input-number controls-position="right" size="small" v-model="priceConfig.xz_discount" :min="0"
                    :max="1" label="填0-1的值" :step="0.1"></el-input-number>
                  <span style="margin-left: 20px;">（备注：填0-1的值）</span>
                </div>
                <div class="">
                  <span>产品版本授权设置</span>
                  <div style="margin-top: 20px;">
                    <el-table :data="priceConfig.xzreports.data" border style="width: 500px" height="499">
                      <el-table-column prop="name" label="名称"> </el-table-column>
                      <el-table-column label="按年市场价" align="center">
                        <template slot-scope="scope">
                          {{ scope.row.price_info.price }}
                        </template>
                      </el-table-column>
                      <el-table-column label="是否开通" align="center">
                        <template slot-scope="scope">
                          <el-checkbox v-model="scope.row.price_info.valid"></el-checkbox>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </el-tab-pane> -->
                        <el-tab-pane :label="priceConfig.xzreports.label" :name="priceConfig.xzreports.id">
                            <el-table :data="priceConfig.xzreports.data" border style="width: 100%" height="600">
                                <el-table-column prop="name" label="名称"> </el-table-column>
                                <el-table-column label="按年开通" align="center">
                                    <template slot-scope="scope">
                                        <el-checkbox v-model="scope.row.price_info.valid"></el-checkbox>
                                    </template>
                                </el-table-column>
                                <el-table-column label="按年结算价格">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.price_info.price"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="买断开通" align="center">
                                    <template slot-scope="scope">
                                        <el-checkbox v-model="scope.row.price_info.buyout_valid"></el-checkbox>
                                    </template>
                                </el-table-column>
                                <el-table-column label="买断结算价格">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.price_info.buyout_price"></el-input>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane label="安捷云产品模块" name="af">
                            <div class="af_main">
                                <div class="af_main_item">
                                    <span style="margin-right: 20px;">伙伴结算折扣</span>
                                    <el-input-number controls-position="right" size="small" v-model="afForm.discount"
                                        :min="0" :max="1" label="填0-1的值" :step="0.1"></el-input-number>
                                    <span style="margin-left: 20px;">（备注：填0-1的值）</span>
                                </div>
                                <div class="">
                                    <span>授权产品线</span><span style="margin-left: 32px;color: #409eff;cursor: pointer;"
                                        @click="addAfCategories">添加</span>
                                    <div style="margin-top: 20px;max-height: 500px;overflow-y: auto;">
                                        <div style="margin-left: 102px;width: 350px;">
                                            <div v-for="(item, index) in afAppsData" :key="index"
                                                style="display: flex;align-items: center;margin-top: 10px;">
                                                <el-input v-model="item.name" placeholder="请输入内容"></el-input>
                                                <i style="width: 20px;color:#409eff;height: 20px;    font-size: 20px;margin-left: 10px;cursor: pointer;"
                                                    class="el-icon-remove-outline"
                                                    @click="removeAfCategories(index)"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="安捷智用产品" name="fdc">
                            <div class="af_main">
                                <div class="af_main_item">
                                    <span style="margin-right: 20px;">伙伴结算折扣</span>
                                    <el-input-number controls-position="right" size="small" v-model="fdcForm.discount"
                                        :min="0" :max="1" label="填0-1的值" :step="0.1"></el-input-number>
                                    <span style="margin-left: 20px;">（备注：填0-1的值）</span>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="hidePriceDialog">取 消</el-button>
                    <el-button class="primary" @click="priceFormSubmit">提 交</el-button>
                </div>
            </el-dialog>
            <!-- 价格设置end -->

            <!-- 账户充值start -->
            <el-dialog title="账户充值" :close-on-click-modal="false" :visible.sync="accoutVisable" width="506px"
                class="triallDialog">
                <el-form :model="accoutFormInfo" ref="accountForm">
                    <el-form-item label="伙伴名称" :label-width="formLabelWidth">
                        <el-input disabled v-model="accoutFormInfo.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="伙伴用户名" :label-width="formLabelWidth">
                        <el-input disabled v-model="accoutFormInfo.username" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="充值类型" :label-width="formLabelWidth">
                        <el-radio-group v-model="accoutFormInfo.rechangeType">
                            <el-radio :label="1">充值</el-radio>
                            <el-radio :label="2">扣除</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="充值币种" :label-width="formLabelWidth">
                        <el-select v-model="accoutForm.type" placeholder="请选择">
                            <el-option v-for="(item, key) in currency" :key="key" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="充值金额" :label-width="formLabelWidth">
                        <el-input v-model="accoutForm.point" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" :label-width="formLabelWidth">
                        <el-input type="textarea" :rows="3" v-model="accoutForm.note" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="hideAccountDialog">取 消</el-button>
                    <el-button class="primary" @click="accountFormSubmit">提 交</el-button>
                </div>
            </el-dialog>
            <!-- 账户充值end -->
            <!-- 重置密码start -->
            <el-dialog title="重置密码" :close-on-click-modal="false" :visible.sync="passwordVisable" width="506px">
                <el-form status-icon :rules="passwordRules" :model="passwordFormInfo" ref="passwordFormInfo">
                    <el-form-item label="伙伴名称" :label-width="formLabelWidth">
                        <el-input disabled v-model="agentFormInfo.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="伙伴用户名" :label-width="formLabelWidth">
                        <el-input disabled v-model="agentFormInfo.user.username" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="pass" :label-width="formLabelWidth">
                        <el-input type="password" v-model="passwordFormInfo.pass" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="checkPass" :label-width="formLabelWidth">
                        <el-input type="password" v-model="passwordFormInfo.checkPass" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="hidePasswordDialog">取 消</el-button>
                    <el-button class="primary" @click="passwordFormSubmit">提 交</el-button>
                </div>
            </el-dialog>
            <!-- 重置密码end -->
        </div>
    </div>
</template>

<script>
import { createGetUrlParams } from '@/utils/url';
// import { getTransaction, getTransactionBySearch } from "@/api/transaction";
import {
    getAgentList,
    getAgentById,
    updateAgent,
    checkAgentPrice,
    getMaintainerList,
    setAgentPrice,
    setRecharge,
    resetPassword,
    antiRecharge,
    setAgentAFPrice
} from '@/api/agent';

// import { getVersionOption } from '../xzReport/utils';

export default {
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.passwordFormInfo.checkPass !== '') {
                    this.$refs.passwordFormInfo.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.passwordFormInfo.pass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            activeName: 'editions',
            priceConfig: {
                editions: { id: 'editions', label: 'FastBI产品版本', data: [] },
                modules: { id: 'modules', label: 'FastBI产品模块', data: [] },
                suits: { id: 'suits', label: 'FastBI应用模块', data: [] },
                xzreports: { id: 'xzreports', label: '小智产品', data: [] },
                fbi_discount: 1,
                // xz_discount:1
            },
            pagination: {
                use: true,
                total: 0,
                size: 20,
                currentPage: 1,
            },
            passwordFormInfo: {
                pass: '',
                checkPass: '',
            },
            passwordRules: {
                pass: [{ validator: validatePass, trigger: 'blur' }],
                checkPass: [{ validator: validatePass2, trigger: 'blur' }],
            },
            passwordVisable: false,
            /*筛选条件-充值时间start*/
            searchOption: {
                partnerName: '', // 伙伴名称
                partnerUser: '', // 伙伴用户名
            },
            /*表格数据start*/
            tableData: [],
            /*表格数据end*/
            formLabelWidth: '110px',

            /*权限开通start*/
            agentVisable: false,
            agentFormInfo: {
                name: '',
                user: '',
                ceo: '',
                phone: '',
                telephone: '',
                email: '',
            },
            agentForm: {
                permission: [],
                staff: '',
                role: [],
                fastbi: [],
                xz: [],
                af: [],
                fdc: [],
            },

            maintainer: [], // 归属维护人
            maintainerMap: {},
            partnerPermission: [
                {
                    id: 0,
                    name: '代理',
                },
                {
                    id: 2,
                    name: 'OEM',
                },
                {
                    id: 3,
                    name: '离线授权',
                },
                {
                    id: 4,
                    name: '渠道维护',
                },
                {
                    id: 5,
                    name: '开发者',
                },
                {
                    id: 6,
                    name: '小智产品',
                },
                {
                    id: 7,
                    name: '安捷云产品',
                },
            ], //伙伴权限
            /*权限开通end*/


            /*新权限开通start*/
            partnerPermission1: [
                {
                    id: 'agent',
                    name: '代理伙伴',
                },
                {
                    id: 'sales',
                    name: '天智销售',
                },
                {
                    id: 'operator',
                    name: '运营管理',
                },
            ],
            partnerPermission2: [
                {
                    id: "product",
                    name: 'FastBI购买',
                },
                {
                    id: 'package',
                    name: 'OCR资源包购买',
                },
                {
                    id: 'softwareDongle',
                    name: '加密狗购买',
                },
                {
                    id: 'offline',
                    name: '离线授权',
                },
                {
                    id: "oem",
                    name: 'OEM管理',
                },
            ],
            partnerPermission3: [
                {
                    id: "sdk",
                    name: '小智SDK购买',
                },
                {
                    id: 'development',
                    name: '开发平台购买',
                }
            ],
            partnerPermission4: [
                {
                    id: 'cloud',
                    name: '公有云产品购买',
                },
                {
                    id: 'local',
                    name: '本地化产品购买',
                }
            ],
            partnerPermission5: [
                {
                    id: 'buy',
                    name: '安捷智用产品购买',
                }
            ],
            /*新权限开通end*/


            /*价格设置start*/
            priceVisable: false,
            priceTableData: [], //数据
            priceTableAllData: [], //全部数据
            /*价格设置end*/

            //账户充值start
            accoutVisable: false,
            accoutForm: {
                type: '',
                point: '',
                note: '',
            },
            accoutFormInfo: {
                name: '',
                username: '',
                rechangeType: 1,
            },
            currency: [
                { id: 6, name: '小智产品专用币' },
                { id: 7, name: '小智产品赠送' },
                { id: 4, name: 'FastBI产品专用币' },
                { id: 2, name: 'FastBI赠送' },
                { id: 1, name: '通用币' },
            ],
            currency: [{ id: 1, name: '通用币' }, { id: 4, name: 'FastBI产品专用币' }, { id: 2, name: 'FastBI赠送' }, { id: 8, name: '安捷云产品专用币' }],
            //账户充值end
            currentAgent: null,
            currentUser: null,
            afForm: {
                discount: 1, // 折扣
                af_categories: [],  // 渠道
            },
            fdcForm: {
                discount: 1, // FDC折扣
            },
            afAppsData: [
                // { name: '用友' },
                // { name: '金蝶' },
                // { name: '万里牛' },
                // { name: '天财商龙' }
            ],
            roleMapping: {
                sales: '_is_sales',
                agent: '_is_agent',
                operator: '_is_operator'
            },
            permissionConfig: {
                fastbi: {
                    product: '_is_product',
                    package: '_is_package',
                    softwareDongle: '_is_softwareDongle',
                    offline: '_is_offline',
                    oem: '_is_oem'
                },
                xz: {
                    sdk: '_is_sdk',
                    development: '_is_development',
                    cloud: '_is_cloud',
                    local: '_is_local'
                }
            }
        };
    },
    mounted() {
        this.getMaintainerList();
    },
    methods: {
        handleClick(tab, event) { },
        getMaintainerList() {
            getMaintainerList()
                .then((res) => {
                    this.maintainer = res;
                    let obj = {};
                    res.forEach((item) => {
                        obj[item.id] = item;
                    });
                    this.maintainerMap = obj;
                    this.getTransactionData();
                })
                .catch((err) => {
                    this.getTransactionData();
                });
        },
        showAccountDialog() {
            this.accoutVisable = true;
        },
        hideAccountDialog() {
            this.accoutForm = {
                type: '',
                point: '',
                note: '',
            };
            this.accoutFormInfo = {
                name: '',
                username: '',
                rechangeType: 1,
            };
            this.accoutVisable = false;
        },
        showPriceDialog() {
            this.priceVisable = true;
        },
        hidePriceDialog() {
            this.priceVisable = false;
            this.afForm = {
                discount: 1, // 折扣
                af_categories: [],  // 渠道
            }
            this.fdcForm = {
                discount: 1, // FDC折扣
            }
            this.updateValidStatus({})
        },
        showAgentDialog() {
            this.agentVisable = true;
        },
        hideAgentDialog() {
            (this.agentFormInfo = {
                name: '',
                user: '',
                ceo: '',
                phone: '',
                telephone: '',
                email: '',
                permission: [],
                maintainer: '',
            }),
                (this.agentForm = {
                    permission: [],
                    staff: '',
                    role: [],
                    fastbi: [],
                    xz: [],
                    af: [],
                    fdc: [],
                });
            this.agentVisable = false;
        },
        // 提交权限开通表单
        agentFormSubmit() {
            if (!this.currentAgent) return;
            let obj = {};
            //   let permission = this.agentForm.permission;
            //   let map = this.permissionMap();
            //   for (const key in map) {
            //     let val = map[key];
            //     if (permission.indexOf(val) != -1) {
            //       obj[key] = true;
            //     } else {
            //       obj[key] = false;
            //     }
            //   }
            //   permission.indexOf(0) != -1 ? (obj.status = 0) : (obj.status = 1);
            obj.roles = this.agentForm.role
            obj.permissions = JSON.stringify({
                fastbi: this.agentForm.fastbi,
                xz: this.agentForm.xz,
                af: this.agentForm.af,
                fdc: this.agentForm.fdc,
            });
            console.log(obj.permissions);

            obj.staff = this.agentForm.staff;
            updateAgent(this.currentAgent, obj)
                .then((res) => {
                    this.getTransactionData();
                    this.hideAgentDialog();
                })
                .catch((err) => { });
        },
        // 提交价格设置表单
        async priceFormSubmit() {
            let dict = {
                editions: 'edition_price_info',
                modules: 'module_price_info',
                suits: 'suit_price_info',
                xzreports: 'xzreport_price_info',
            };
            let obj = {
                user: this.currentUser,
                edition_price_info: [],
                module_price_info: [],
                suit_price_info: [],
                xzreport_price_info: [],
                fbi_discount: this.priceConfig.fbi_discount,
                // xz_discount:this.priceConfig.xz_discount,
                fdc_discount: this.fdcForm.discount,
            };
            let priceConfig = JSON.parse(JSON.stringify(this.priceConfig))
            console.log(priceConfig);
            for (const key in priceConfig) {
                let data = priceConfig[key].data;
                if (Array.isArray(data)) {
                    if (key == "xzreports") {
                        data.map((item) => {
                            if (item.grade !== undefined) {
                                item.price_info.grade = item.grade;
                            }
                            if (
                                item.price_info.price !== '' &&
                                item.price_info.price != null &&
                                item.price_info.buyout_price != null &&
                                item.price_info.buyout_price !== ''
                            ) {
                                if (obj[dict[key]]) {
                                    obj[dict[key]].push(item.price_info);
                                }
                            }
                        });
                    } else {
                        data.map((item) => {
                            if (item.grade !== undefined) {
                                item.price_info.grade = item.grade;
                            }
                            delete item.price_info.price
                            delete item.price_info.buyout_price
                            delete item.price_info.buyout_valid

                            if (obj[dict[key]]) {
                                obj[dict[key]].push(item.price_info);
                            }
                        });
                    }

                }

            }

            await setAgentPrice(obj)
                .then((res) => {
                })
                .catch((err) => { });
            const af_categories = this.afAppsData.map(item => {
                return item.name
            })
            await setAgentAFPrice({ agent: obj.user, discount: this.afForm.discount, af_categories }).then(res => {

            }).catch((err) => {
                console.log(err);

            });
            this.hidePriceDialog();

        },
        addAfCategories() {
            this.afAppsData.push({
                name: ""
            })
        },
        removeAfCategories(index) {
            this.afAppsData.splice(index, 1)
        },
        // 提交账户充值表单
        accountFormSubmit() {
            if (this.accoutFormInfo.rechangeType == 2) {
                //扣除
                antiRecharge({ id: this.currentUser, ...this.accoutForm })
                    .then((res) => {
                        this.hideAccountDialog();
                    })
                    .catch((err) => { });
            } else {
                // 充值
                setRecharge({ id: this.currentUser, ...this.accoutForm })
                    .then((res) => {
                        this.hideAccountDialog();
                    })
                    .catch((err) => { });
            }
        },

        permissionMap() {
            return {
                allow_oem: 2,
                allow_offline: 3,
                is_developer: 5,
                is_maintainer: 4,
                allow_xzreport: 6,
                allow_af: 7
            };
        },
        /**
         * @description: 权限开通
         * @param {*}
         * @return {void}
         */
        permissionOpen(index, row) {
            this.currentAgent = row.id;
            console.log(row);

            getAgentById(row.id)
                .then((res) => {
                    this.agentFormInfo = res;
                    if (!this.agentFormInfo.user) {
                        //可能存在空 影响后续判断
                        this.agentFormInfo.user = {};
                    }
                    // let npermission = [];
                    // let map = this.permissionMap();
                    // for (const key in map) {
                    //   if (res[key]) {
                    //     npermission.push(map[key]);
                    //   }
                    // }
                    // 是代理
                    // if (res.status === 0) {
                    //   npermission.push(0);
                    // }

                    // this.agentForm.permission = npermission;
                    let role = []
                    if (row.roles) {
                        if (Array.isArray(row.roles)) {
                            role = row.roles
                        } else {
                            role = JSON.parse(row.roles)
                        }

                    }
                    let fastbi = []
                    let xz = []
                    let af = []
                    let fdc = []
                    if (row.permissions) {
                        let permissions = JSON.parse(row.permissions)
                        fastbi = permissions['fastbi'] || []
                        xz = permissions['xz'] || []
                        af = permissions['af'] || []
                        fdc = permissions['fdc'] || []
                    }
                    this.agentForm.fastbi = fastbi
                    this.agentForm.xz = xz
                    this.agentForm.af = af
                    this.agentForm.fdc = fdc
                    this.agentForm.role = role
                    this.agentForm.staff = res.staff;
                    this.showAgentDialog();
                })
                .catch((err) => {
                    console.log(err);

                });
        },
        dealPriceData(data) {
            for (const key in data) {
                let res = data[key];
                if (Array.isArray(res)) {
                    res.map((item) => {
                        if (!item.price_info) {
                            item.price_info = {
                                [key]: item.id,
                                valid: false,
                                buyout_valid: false,
                                price: null,
                                buyout_price: null,
                            };
                        }
                        return item;
                    });
                    if (this.priceConfig[key]) {
                        this.priceConfig[key].data = res;
                    }
                } else {
                    if (key == "afmodule_discount") {
                        this.afForm.discount = res
                    }
                    if (key == "fdc_discount") {
                        this.fdcForm.discount = res
                    }
                }
                if (key === 'xzreports') {
                    /* 去除小智产品免费版 */
                    this.priceConfig[key].data = this.priceConfig[key].data.filter((i) => {
                        return i.grade !== 1;
                    });
                }

            }
            console.log(data, this.priceConfig);
            this.priceConfig.fbi_discount = data['fbi_discount']
            // this.priceConfig.xz_discount = data['xz_discount']

        },
        updateValidStatus(res) {
            if (res.af_categories) {
                this.afAppsData = res.af_categories.map(item => {
                    return { name: item }
                })
            } else {
                this.afAppsData = []
            }
        },
        /**
         * @description: 价格设置
         * @param {*}
         * @return {void}
         */
        async priceSetting(index, row) {
            this.currentUser = row.userid;
            this.activeName = 'editions';
            await getAgentById(row.id).then(res => {
                console.log(res);

                this.updateValidStatus(res)
            })

            await checkAgentPrice({ user: row.userid })
                .then((res) => {
                    this.dealPriceData(res);
                    this.showPriceDialog();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        /**
         * @description: 账户充值
         * @param {*}
         * @return {*}
         */
        accountRecharge(index, row) {
            this.accoutFormInfo.name = row.name;
            this.accoutFormInfo.username = row.username;
            this.currentUser = row.userid;
            this.showAccountDialog();
        },
        hidePasswordDialog() {
            this.$refs.passwordFormInfo.resetFields();
            this.agentFormInfo = {
                name: '',
                user: '',
                ceo: '',
                phone: '',
                telephone: '',
                email: '',
                permission: [],
                maintainer: '',
            };
            this.passwordFormInfo = {
                pass: '',
                checkPass: '',
            };
            this.passwordVisable = false;
        },
        showPasswordDialog() {
            this.passwordVisable = true;
        },
        // 重置密码
        resetPassword(index, row) {
            this.currentAgent = row.id;
            console.log(this.currentUser, row.userid, 'this.currentUser');
            this.currentUser = row.userid;
            getAgentById(row.id)
                .then((res) => {
                    this.agentFormInfo = res;
                    this.showPasswordDialog();
                })
                .catch((err) => { });
        },
        // 提交重置密码表单
        passwordFormSubmit() {
            this.$refs['passwordFormInfo'].validate((valid) => {
                if (valid) {
                    // alert('submit!');
                    let obj = {
                        id: this.currentUser,
                        password: this.passwordFormInfo.pass,
                    };
                    resetPassword(obj)
                        .then((res) => {
                            this.hidePasswordDialog();
                        })
                        .catch((err) => { });
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        handleCurrentChange(val) {
            this.pagination.currentPage = val;
            this.getTransactionData();
        },
        handleSizeChange(val) {
            if (val <= this.pagination.total) {
                this.pagination.size = val;
                this.getTransactionData();
            }
        },
        getTransactionData() {
            this.loading = true;
            let params = {
                p: this.pagination.currentPage,
                count: this.pagination.size,
                category: 1,
                name: this.searchOption.name,
                username: this.searchOption.username,
            };
            let result = createGetUrlParams(params);
            if (result.success) {
                getAgentList(result.data)
                    .then((response) => {
                        this.loading = false;
                        this.pagination.total = response.count | 0;

                        this.tableData = response.results;
                        this.deal_agent_data()

                    })
                    .catch(() => {
                        this.loading = false;
                    });
            }
        },

        deal_agent_data() {
            this.tableData.map((item) => {
                if (item.roles && Array.isArray(item.roles)) {
                    console.log(item)
                    if (item.roles.includes("sales")) {
                        item._is_sales = "是"
                    } else {
                        item._is_sales = "否"
                    }
                    if (item.roles.includes("agent")) {
                        item._is_agent = "是"
                    } else {
                        item._is_agent = "否"
                    }
                    if (item.roles.includes("operator")) {
                        item._is_operator = "是"
                    } else {
                        item._is_operator = "否"
                    }
                } else {
                    item._is_sales = "否"
                    item._is_agent = "否"
                    item._is_operator = "否"
                }
                if (item.permissions) {
                    const permissions = JSON.parse(item.permissions)
                    const fbi = permissions.fastbi
                    const xz = permissions.xz
                    const af = permissions.af
                    const fdc = permissions.fdc
                    if (fbi) {
                        if (fbi.includes("product")) {
                            item._is_product = "是"
                        } else {
                            item._is_product = "否"
                        }
                        if (fbi.includes("package")) {
                            item._is_package = "是"
                        } else {
                            item._is_package = "否"

                        }
                        if (fbi.includes("softwareDongle")) {
                            item._is_softwareDongle = "是"
                        } else {
                            item._is_softwareDongle = "否"

                        }
                        if (fbi.includes("offline")) {
                            item._is_offline = "是"
                        } else {
                            item._is_offline = "否"

                        }
                        if (fbi.includes("oem")) {
                            item._is_oem = "是"
                        } else {
                            item._is_oem = "否"
                        }
                    } else {
                        item._is_product = "否"
                        item._is_package = "否"
                        item._is_softwareDongle = "否"
                        item._is_offline = "否"
                        item._is_oem = "否"
                    }
                    if (xz) {
                        if (xz.includes("sdk")) {
                            item._is_sdk = "是"
                        } else {
                            item._is_sdk = "否"
                        }
                        if (xz.includes("development")) {
                            item._is_development = "是"
                        } else {
                            item._is_development = "否"
                        }
                    } else {
                        item._is_sdk = "否"
                        item._is_development = "否"
                    }
                    if (af) {
                        if (af.includes("cloud")) {
                            item._is_cloud = "是"
                        } else {
                            item._is_cloud = "否"
                        }
                        if (af.includes("local")) {
                            item._is_local = "是"
                        } else {
                            item._is_local = "否"
                        }
                    } else {
                        item._is_cloud = "否"
                        item._is_local = "否"
                    }
                    if (fdc) {
                        if (fdc.includes("buy")) {
                            item._is_fdc = "是"
                        } else {
                            item._is_fdc = "否"
                        }
                    } else {
                        item._is_fdc = "否"
                    }
                } else {
                    item._is_product = "否"
                    item._is_package = "否"
                    item._is_softwareDongle = "否"
                    item._is_offline = "否"
                    item._is_oem = "否"
                    item._is_sdk = "否"
                    item._is_development = "否"
                    item._is_cloud = "否"
                    item._is_local = "否"
                    item._is_fdc = "否"
                }
            })
        },
        search() {
            this.restPage(true);
            let params = {
                p: this.pagination.currentPage,
                count: this.pagination.size,
                name: this.searchOption.name,
                username: this.searchOption.username,
            };
            let result = createGetUrlParams(params);

            if (result.success) {
                this.loading = true;
                getAgentList(result.data)
                    .then((response) => {
                        this.tableData = response.results;
                        this.deal_agent_data()

                        this.pagination.total = response.count;
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            }
        },
        restPage(isUsePagination) {
            this.pagination.use = isUsePagination;
            this.pagination.currentPage = 1;
            this.pagination.size = 20;
        },
        restSearch() {
            for (const key in this.searchOption) {
                if (this.searchOption.hasOwnProperty(key)) {
                    this.searchOption[key] = '';
                }
            }
            this.restPage(true);
            this.getTransactionData();
        },
    },
};
</script>

<style lang="scss">
@import url('../../assets/css/system.css');

.agent {
    .main {
        display: flex;
        flex-direction: column;
        margin: 0px 14px;
        height: 100%;
        //background-color: #FFFFFF;
        position: absolute;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;

        .main_title {
            margin: 15px 0;
        }

        .product-selector {
            height: 37px !important;
            background: #fff;

            .selector-center {
                margin-left: 0 !important;
                width: 400px !important;
            }
        }

        .group {
            p {
                margin: 10px 15px 10px 5px !important;
                float: left !important;
                width: 80px !important;
                height: 32px !important;
                line-height: 32px !important;
                text-align: right !important;
            }
        }

        .group .el-input {
            float: left !important;
            margin: 10px 0px !important;
            width: 200px !important;
        }

        .product-main-list {
            flex-grow: 1;
            height: 50%;
        }

        .selector-right {
            height: 100% !important;
            line-height: 50px !important;
        }
    }
}

/*筛选部分start*/
.agent-selector {
    padding: 18px 0px 20px 24px !important;
    min-width: 980px !important;
    font-size: 12px !important;
    height: 32px !important;
    background: #fff;
}

.select-item {
    float: left;
    margin-right: 34px;

    .el-select {
        width: auto;
    }
}

.af_main {
    .af_main_item {
        display: flex;
        align-items: center;
        margin-top: 10px;
        margin-bottom: 20px;
    }
}

.select-item .el-date-editor {
    width: 180px;
}

.select-item .el-input__inner {
    padding-right: 0px;
}

.select-item p {
    padding-right: 10px;
    float: left;
    height: 32px;
    line-height: 32px;
    text-align: right;
}

.select-input {
    float: left;
    width: 180px;
}

.selcet-product .el-input__inner {
    width: 150px;
    height: 32px;
    line-height: 32px;
}

.el-select-dropdown__list {
    padding: 6px 0px 22px 0px;
}

.el-select-dropdown span {
    font-size: 12px;
}

/*筛选部分end*/

.agent-main-line {
    width: 100%;
    border-bottom: 1px solid #ededed;
}

/*订单列表start*/
.agent-main-list {
    min-width: 1100px;
    flex-grow: 1;
    height: 50%;
    /*margin-top: 10px;*/
    /*margin:35px 30px 0px 30px;*/
}

.agent-main-list .cell span {
    font-size: 12px;
}

/*订单列表end*/
.account-table {
    .el-input__inner {
        height: 30px;
    }
}

.af_main {
    .el-input__inner {
        height: 32px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/system/agent.vue